import type {
  BranchAddressPayload,
  BranchBasicInfoPayload,
  CreateBranchPayload,
  GetBranchesListParams,
  GetBranchesResponse,
  GetSingleBranchResponse,
  LinkedBranchesResponse,
  SetupFirstBranchesPayload,
  SetupFirstBranchesResponse,
} from '../types/branches';
import api from './client';

function getBaseUrl(companyId: string) {
  return <const>`/companies/${companyId}/branches`;
}

export async function getBranches(
  companyId: string,
  params: GetBranchesListParams
) {
  const res = await api.get<GetBranchesResponse>(getBaseUrl(companyId), {
    params,
  });
  return res.data;
}

//get single branch
export async function getSingleBranch(companyId: string, id: string) {
  const res = await api.get<GetSingleBranchResponse>(
    `${getBaseUrl(companyId)}/${id}`
  );
  return res.data;
}

//toggle branch status
export async function toggleBranchStatus(companyId: string, id: string) {
  const res = await api.patch<GetSingleBranchResponse>(
    `${getBaseUrl(companyId)}/${id}/status`
  );
  return res.data;
}

// soft-delete a branch (refused for the default one and one with active employees)
export async function deleteBranch(companyId: string, id: string) {
  const res = await api.delete<{ data: { id: string } }>(
    `${getBaseUrl(companyId)}/${id}`
  );
  return res.data;
}

// v2 routes check each location's country, province and city.
const V2 = { baseURL: '/api/v2' };

//set-up first branch
export async function setupFirstBranch(
  companyId: string,
  payload: SetupFirstBranchesPayload
) {
  const res = await api.post<SetupFirstBranchesResponse>(
    `${getBaseUrl(companyId)}/setup-first-branch`,
    payload,
    V2
  );
  return res.data;
}

//create new branch
export async function createNewBranch(
  companyId: string,
  payload: CreateBranchPayload
) {
  const res = await api.post<GetSingleBranchResponse>(
    getBaseUrl(companyId),
    payload,
    V2
  );
  return res.data;
}
// update basic info
export async function updateBranchBasicInfo(
  companyId: string,
  id: string,
  payload: BranchBasicInfoPayload
) {
  const res = await api.put<GetSingleBranchResponse>(
    `/companies/${companyId}/branches/${id}/update-basic-info`,
    payload
  );
  return res.data;
}

// update address info
export async function updateBranchAddressInfo(
  companyId: string,
  id: string,
  payload: BranchAddressPayload
) {
  const res = await api.put<GetSingleBranchResponse>(
    `/companies/${companyId}/branches/${id}/update-address-info`,
    payload,
    V2
  );
  return res.data;
}

// update branch managers
export async function updateBranchManagers(
  companyId: string,
  id: string,
  payload: { branchAdminIds: string[] }
) {
  const res = await api.put<GetSingleBranchResponse>(
    `/companies/${companyId}/branches/${id}/branch-manager`,
    payload
  );
  return res.data;
}

export async function getLinkedBranches(companyId: string) {
  const res = await api.get<LinkedBranchesResponse>(
    `/companies/${companyId}/branches/linked-branches`
  );
  return res.data;
}
